export type ConsentDecision = 'accepted' | 'rejected' | 'unset';

export type CookieConsentProviderId = 'clarity' | 'googleAnalytics' | 'youtube';

export interface CookieConsentState {
  version: 1;
  clarity: ConsentDecision;
  googleAnalytics: ConsentDecision;
  youtube: ConsentDecision;
  updatedAt: string;
}

export interface CookieConsentPreferences {
  clarity: ConsentDecision;
  googleAnalytics: ConsentDecision;
  youtube: ConsentDecision;
}

export const COOKIE_CONSENT_STORAGE_KEY = 'neocredito.cookieConsent.v1';
export const LEGACY_CONSENT_STORAGE_KEY = 'consent.analytics';

export const DEFAULT_UNSET_CONSENT: CookieConsentPreferences = {
  clarity: 'unset',
  googleAnalytics: 'unset',
  youtube: 'unset',
};

export interface CookieConsentProviderDefinition {
  id: CookieConsentProviderId;
  label: string;
  description: string;
  relatedCookies: string[];
  configurable: boolean;
}
